import { getLink, statusMapActionToLabel } from "./utils";
var useStatusHandlers = function useStatusHandlers(_ref) {
  var clearCancellationDefaultState = _ref.clearCancellationDefaultState,
    info = _ref.info,
    onActionClick = _ref.onActionClick,
    setCancellationAction = _ref.setCancellationAction,
    setCancellationActionLink = _ref.setCancellationActionLink,
    setCancellationDefaultState = _ref.setCancellationDefaultState,
    setCancellationReasonModalVisible = _ref.setCancellationReasonModalVisible;
  var onEditReasonHandler = function onEditReasonHandler() {
    var link = getLink(info, 'edit_reason');
    if (!link) {
      return;
    }
    var cancellationAction = info.status.canceled ? 'cancel' : 'withdraw';
    setCancellationDefaultState(info.status.cancellation_reason_id, info.status.cancellation_additional_note);
    setCancellationReasonModalVisible(true);
    setCancellationAction(cancellationAction);
    setCancellationActionLink(link);
  };
  var onCancelHandler = function onCancelHandler() {
    var link = getLink(info, 'cancel');
    if (link) {
      setCancellationReasonModalVisible(true);
      setCancellationAction('cancel');
      setCancellationActionLink(link);
    }
  };
  var onUncancelHandler = function onUncancelHandler() {
    var eventData = {
      eventName: 'Single Application - Status - Clicked Confirm To Uncheck Cancel'
    };
    onActionClick({
      _event: null,
      flagName: 'uncancel',
      flagValue: true,
      eventData: eventData
    });
  };
  var onEnableRefundInProgressHandler = function onEnableRefundInProgressHandler() {
    var eventData = {
      eventName: 'Single Application - Status - Clicked Confirm To Update Status To Refund In Progress',
      includeStatuses: true
    };
    onActionClick({
      _event: null,
      flagName: 'refund_in_progress',
      flagValue: true,
      eventData: eventData
    });
  };
  var onCancelRefundInProgressHandler = function onCancelRefundInProgressHandler() {
    var eventData = {
      eventName: 'Single Application - Status - Clicked Confirm To Uncheck Refund In Progress',
      includeStatuses: true
    };
    onActionClick({
      _event: null,
      flagName: 'refund_in_progress',
      flagValue: false,
      eventData: eventData
    });
  };
  var onEnableDeferralInProgressHandler = function onEnableDeferralInProgressHandler() {
    var eventData = {
      eventName: 'Single Application - Status - Clicked Confirm To Update Status To Defferal In Progress',
      includeStatuses: true
    };
    onActionClick({
      _event: null,
      flagName: 'deferral_in_progress',
      flagValue: true,
      eventData: eventData
    });
  };
  var onCancelDeferralInProgressHandler = function onCancelDeferralInProgressHandler() {
    var eventData = {
      eventName: 'Single Application - Status - Clicked Confirm To Uncheck Defferal In Progress',
      includeStatuses: true
    };
    onActionClick({
      _event: null,
      flagName: 'deferral_in_progress',
      flagValue: false,
      eventData: eventData
    });
  };
  var onReactivateHandler = function onReactivateHandler() {
    var eventData = {
      eventName: 'Single Application - Status - Clicked Confirm To Uncheck Withdraw'
    };
    onActionClick({
      _event: null,
      flagName: 'reactivate',
      flagValue: true,
      eventData: eventData
    });
  };
  var onWithdrawHandler = function onWithdrawHandler() {
    var link = getLink(info, 'withdraw');
    if (link) {
      setCancellationReasonModalVisible(true);
      setCancellationAction('withdraw');
      setCancellationActionLink(link);
    }
  };
  var onUndecideHandler = function onUndecideHandler() {
    var eventData = {
      eventName: 'Single Application - Status - Clicked Confirm To Undecide Status'
    };
    onActionClick({
      _event: null,
      flagName: 'undecide',
      flagValue: true,
      eventData: eventData
    });
  };
  var onAdmissionDropdownChange = function onAdmissionDropdownChange(value) {
    var eventData = {
      eventName: "Single Application - Status - Clicked Confirm To Update Status To ".concat(statusMapActionToLabel[value])
    };
    onActionClick({
      _event: null,
      flagName: value,
      flagValue: true,
      eventData: eventData
    });
  };
  var onCloseCancellationReasonModal = function onCloseCancellationReasonModal() {
    setCancellationReasonModalVisible(false);
    clearCancellationDefaultState();
  };
  var onEnableReadyToEnrollHandler = function onEnableReadyToEnrollHandler() {
    var eventData = {
      eventName: 'Single Application - Status - Clicked Confirm To Update Status To Ready To Enroll'
    };
    onActionClick({
      _event: null,
      flagName: 'ready_to_enroll',
      flagValue: true,
      eventData: eventData
    });
  };
  var onCancelReadyToEnrollHandler = function onCancelReadyToEnrollHandler() {
    var eventData = {
      eventName: 'Single Application - Status - Clicked Confirm To Uncheck Ready To Enroll'
    };
    onActionClick({
      _event: null,
      flagName: 'ready_to_enroll',
      flagValue: false,
      eventData: eventData
    });
  };
  var onEnableEnrollmentConfirmedHandler = function onEnableEnrollmentConfirmedHandler() {
    var eventData = {
      eventName: 'Single Application - Status - Clicked Confirm To Update Status To Enrollment Confirmed',
      includeStatuses: true
    };
    onActionClick({
      _event: null,
      flagName: 'enrollment_confirmed',
      flagValue: true,
      eventData: eventData
    });
  };
  var onCancelEnrollmentConfirmedHandler = function onCancelEnrollmentConfirmedHandler() {
    var eventData = {
      eventName: 'Single Application - Status - Clicked Confirm To Uncheck Enrollment Confirmed',
      includeStatuses: true
    };
    onActionClick({
      _event: null,
      flagName: 'enrollment_confirmed',
      flagValue: false,
      eventData: eventData
    });
  };
  return {
    onAdmissionDropdownChange: onAdmissionDropdownChange,
    onEditReasonHandler: onEditReasonHandler,
    onCancelHandler: onCancelHandler,
    onUncancelHandler: onUncancelHandler,
    onEnableRefundInProgressHandler: onEnableRefundInProgressHandler,
    onCancelRefundInProgressHandler: onCancelRefundInProgressHandler,
    onEnableDeferralInProgressHandler: onEnableDeferralInProgressHandler,
    onCancelDeferralInProgressHandler: onCancelDeferralInProgressHandler,
    onReactivateHandler: onReactivateHandler,
    onWithdrawHandler: onWithdrawHandler,
    onUndecideHandler: onUndecideHandler,
    onCloseCancellationReasonModal: onCloseCancellationReasonModal,
    onEnableReadyToEnrollHandler: onEnableReadyToEnrollHandler,
    onCancelReadyToEnrollHandler: onCancelReadyToEnrollHandler,
    onEnableEnrollmentConfirmedHandler: onEnableEnrollmentConfirmedHandler,
    onCancelEnrollmentConfirmedHandler: onCancelEnrollmentConfirmedHandler
  };
};
export default useStatusHandlers;